import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { css, cx } from "@emotion/css";
import $ from "jquery";
import { useEffect, useRef, useState } from "react";
import { useGoogleAdAvailability } from "../AdComponent/googleAdAvailability";
import { isNotUndefined, showGoogleAds } from "../FunctionsCore";
import { addToRenderableData, classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import SkyscraperAdComponentStyles from "./SkyscraperAdComponentStyles.module.scss";
const styles = SkyscraperAdComponentStyles;
const classCombiner = classCombinerFromPrefix("b134bde72300ecb9");
const getWindowGoogletag = () => window["googletag"];
const SkyscraperAd = (properties) => {
    const referenceObject = useRef(null);
    const addDefaultTop = 155;
    const hide = properties.hide;
    const skyscraperAdDataWithAdSizeParsed = properties.skyscraperAdDataWithAdSizeParsed;
    const height = skyscraperAdDataWithAdSizeParsed.height;
    const adDivId = skyscraperAdDataWithAdSizeParsed.adDivId;
    const isAdLeft = properties.index % 2 === 0;
    const [notOverlappingWithDrift, setNotOverlappingWithDrift] = useState(false);
    const [topPosition, setTopPosition] = useState(addDefaultTop);
    const [showAdd, setShowAdd] = useState(false);
    const [addTriggered, setAddTriggered] = useState(false);
    useEffect(() => {
        const bootomSpace = isAdLeft ? 50 : 150;
        if (isNotUndefined(referenceObject.current)) {
            const determineAndSetNotOverlappingWithDrift = () => setNotOverlappingWithDrift(referenceObject.current.getBoundingClientRect().top + height < window.innerHeight - bootomSpace);
            $(window).on("resize", determineAndSetNotOverlappingWithDrift).on("scroll", determineAndSetNotOverlappingWithDrift);
            determineAndSetNotOverlappingWithDrift();
        }
        if (window.innerWidth >= 1200) {
            $(window).on("scroll", () => {
                const element = $(".companyAnchorsComponent.fixed");
                if (isNotUndefined(element)) {
                    const elementTop = window.Number.parseInt(element.css("top"));
                    if (topPosition !== elementTop) {
                        if (elementTop > 0) {
                            setTopPosition(addDefaultTop + elementTop);
                        }
                        else {
                            setTopPosition(addDefaultTop);
                        }
                    }
                }
            });
        }
    }, []);
    useEffect(() => {
        if (notOverlappingWithDrift) {
            setShowAdd(true);
        }
    }, [notOverlappingWithDrift]);
    useEffect(() => {
        if (!hide && showAdd && !addTriggered) {
            properties.windowGoogletag.cmd.push(() => {
                const newWindowGoogletag = getWindowGoogletag();
                const pubads = newWindowGoogletag.pubads();
                newWindowGoogletag.defineSlot(skyscraperAdDataWithAdSizeParsed.adUnitPath, [skyscraperAdDataWithAdSizeParsed.width, height], adDivId).addService(pubads);
                pubads.enableSingleRequest();
                pubads.enableLazyLoad();
                newWindowGoogletag.enableServices();
                newWindowGoogletag.display(adDivId);
                setAddTriggered(true);
            });
            const bottomContainer = $(".add-break-section");
            const offset = bottomContainer.offset();
            if (isNotUndefined(offset)) {
                properties.onHeightUpdate(offset.top - 800);
            }
        }
    }, [hide, showAdd]);
    return _jsx("div", { className: cx(classCombiner(styles, "skyscraperAd"), classCombiner(styles, `isAdLeft-${isAdLeft}`), classCombiner(styles, `notOverlappingWithDrift-${notOverlappingWithDrift}`), skyscraperAdDataWithAdSizeParsed.heightWidthClassName), id: adDivId, ref: referenceObject, style: { "top": topPosition } });
};
const SkyscraperAds = (properties) => {
    const [hide, setHide] = useState(true);
    const [height, setHeight] = useState(6000);
    const onHeightUpdate = (evnt) => {
        setHeight(evnt);
    };
    useEffect(() => {
        const mediaQueryList = window.matchMedia("(max-width: 1199px)");
        const set = (me, listener, outsideListener) => {
            if (me.matches) {
                if (outsideListener) {
                    mediaQueryList.addEventListener("change", listener);
                }
            }
            else {
                setHide(false);
                mediaQueryList.removeEventListener("change", listener);
            }
        };
        const listener = (me) => set(me, listener, false);
        set(mediaQueryList, listener, true);
    }, []);
    return (_jsx("div", Object.assign({ className: cx(classCombiner(styles, "skyscraperParent")), style: { "height": height } }, { children: _jsx("div", Object.assign({ className: cx(classCombiner(styles, "skyscraperContent")) }, { children: properties.skyscraperAdDataWithAdSizeParsedArray.map((skyscraperAdDataWithAdSizeParsed, index) => (_jsx(SkyscraperAd, { hide: hide, index: index, onHeightUpdate: onHeightUpdate, skyscraperAdDataWithAdSizeParsed: skyscraperAdDataWithAdSizeParsed, windowGoogletag: properties.windowGoogletag }, index))) })) })));
};
const SkyscraperAdComponent = (properties) => {
    const skyscraperAdDataWithAdSizeParsedArray = properties.skyscraperAdDataWithAdSizeParsedArray;
    const [advertisingConsentGiven, setAdvertisingConsentGiven] = useState(false);
    const [windowGoogletag, setWindowGoogletag] = useState(false);
    const addAvailable = useGoogleAdAvailability();
    useEffect(() => {
        const displayAds = () => {
            if (showGoogleAds()) {
                setAdvertisingConsentGiven(true);
                const windowElement = getWindowGoogletag();
                const windowGoogletagRef = isNotUndefined(windowElement) ? windowElement : { "cmd": [] };
                setWindowGoogletag(windowGoogletagRef);
            }
        };
        if (addAvailable) {
            displayAds();
        }
    }, [addAvailable]);
    return (!advertisingConsentGiven
        ? _jsx(_Fragment, {})
        : _jsx(SkyscraperAds, { skyscraperAdDataWithAdSizeParsedArray: skyscraperAdDataWithAdSizeParsedArray, windowGoogletag: windowGoogletag }));
};
const skyscraperAdComponent = (renderableData) => {
    const windowElement = getWindowGoogletag();
    const windowGoogletag = isNotUndefined(windowElement) ? windowElement : { "cmd": [] };
    const skyscraperAdDataWithAdSizeParsedArray = renderableData.data.skyscraperAdData.map((sk) => {
        const adSizeParsed = window.JSON.parse(sk.adSize);
        const height = adSizeParsed[1];
        const width = adSizeParsed[0];
        const skyscraperAdDataWithAdSizeParsed = Object.assign(Object.assign({}, sk), { "height": height, "heightWidthClassName": css({
                "height": `${height}px`,
                "width": `${width}px`,
            }), "width": width });
        return skyscraperAdDataWithAdSizeParsed;
    });
    renderIdentifierGeneric(SkyscraperAdComponent, addToRenderableData(renderableData, {
        "skyscraperAdDataWithAdSizeParsedArray": skyscraperAdDataWithAdSizeParsedArray,
        "windowGoogletag": windowGoogletag
    }));
};
export { skyscraperAdComponent };
